var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"items":_vm.actualPage},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{attrs:{"href":item.path}},[_c('v-icon',{attrs:{"color":"primary","left":""},domProps:{"textContent":_vm._s(item.icon)}}),_c('span',{domProps:{"textContent":_vm._s(item.title)}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }